import React from 'react';
import styles from './styles.module.css';
import MainIcons from '@/icons/main';

export default function AppRadiochecked({
  active,
  iconSize = '13px',
}: {
  active?: boolean;
  iconSize?: string;
}) {
  return (
    <span className={`${styles.radio} ${active && styles.activeRadio}`}>
      <MainIcons.CheckedIcon fill={`var(--paper)`} width={iconSize} height={iconSize} />
    </span>
  );
}
